module.exports = __webpack_public_path__ + "media/images/products/market-mobile-629ab3abfeadfc894d85edf7c0e15ac2.png";